//need double verification
const portalLayer2 = [
    {
        icon: "01n",
        description: "clear sky",
        style: 
            {
            backgroundImage: "var(--FullSky_Night)",
            backgroundSize: "cover",
            transform: "rotate(90deg)",
            opacity: "0.1",
            },
    },
    {
        icon: "02d",
        description: "few clouds",
        style: 
            {
            backgroundImage: "var(--FewClouds_Day)",
            backgroundSize: "cover",
            transform: "rotate(-45deg)",
            opacity: "1",
            animation: "wind 700s linear infinite",
            },
    },
    {
        icon: "02n",
        description: "few clouds",
        style: 
            {
            backgroundImage: "var(--FewClouds_Night)",
            backgroundSize: "cover",
            transform: "rotate(-45deg)",
            opacity: "1",
            animation: "wind 700s linear infinite",
            },
    },
    {
        icon: "03d",
        description: "scattered clouds",
        style: 
            {
            backgroundImage: "var(--ScatteredClouds_Day)",
            backgroundSize: "cover",
            opacity: "1",
            animation: "wind 500s linear infinite",
            },

    },
    {
        icon: "03n",
        description: "scattered clouds",
        style: 
            {
            backgroundImage: "var(--ScatteredClouds_Night)",
            backgroundSize: "cover",
            opacity: "0.3",
            animation: "wind 500s linear infinite",
            },
    },
    {
        icon: "04d",
        description: "broken clouds",
        style:
            {
            backgroundImage: "var(--BrokenClouds_Day)",
            backgroundSize: "cover",
            opacity: "1",
            transform: "rotate(-30deg)",
            animation: "wind 300s linear infinite",
            },
    },
    {
        icon: "04n",
        description: "broken clouds",
        style:
            {
            backgroundImage: "var(--BrokenClouds_Night)",
            backgroundSize: "cover",
            opacity: "0.6",
            transform: "rotate(-30deg)",
            animation: "wind 300s linear infinite",
            },
    },
    {
        icon: "05d",
        description: "overcast clouds",
        style: 
            {
            backgroundImage: "var(--OvercastClouds_Day)",
            backgroundSize: "cover",
            opacity: "1",
            transform: "rotate(-10deg)",
            animation: "wind 800s linear infinite",
            },
    },
    {
        icon: "05n",
        description: "overcast clouds",
        style:
            {
            backgroundImage: "var(--OvercastClouds_Night)",
            backgroundSize: "cover",
            opacity: "0.5",
            transform: "rotate(-10deg)",
            animation: "wind 800s linear infinite",
            },
    },
    {
        icon: "09d",
        description: "shower rain",
        style:
            {
            backgroundImage: "var(--Drizzle_Day)",
            backgroundSize: "50% 50%",
            opacity: "0.4",
            animation: "rain 0.7s linear infinite",
            },
    },
    {
        icon: "09n",
        description: "shower rain",
        style:
            {
            backgroundImage: "var(--Drizzle_Night)",
            backgroundSize: "50% 50%",
            opacity: "0.1",
            filter: "blur(1px)",
            animation: "rain 0.6s linear infinite",
            },
    },
    {
        icon: "10d",
        description: "rain",
        style:
            {
            backgroundImage: "var(--Large_Rain)",
            opacity: "0.3",
            filter: "blur(1px)",
            animation: "rain 0.3s linear infinite",
            backgroundSize: "50% 50%",
            },
    },
    {
        icon: "10n",
        description: "rain",
        style:
            {
            backgroundImage: "var(--Large_Rain)",
            opacity: "0.2",
            filter: "blur(1px)",
            animation: "rain 0.4s linear infinite",
            backgroundSize: "50% 50%",
            },
    },
    {
        icon: "11d",
        description: "thunderstorm",
        style: 
            {
            backgroundImage: "var(--Lightning_Day)",
            backgroundSize: "cover",
            opacity: "0",
            animation: "flash 10s linear 20",
            animationDelay: "2s",
            }
    },
    {
        icon: "11n",
        description: "thunderstorm",
        style: 
            {
            backgroundImage: "var(--Lightning_Night)",
            backgroundSize: "cover",
            opacity: "0",
            animation: "flash 10s linear 20",
            animationDelay: "2s", 
            },
    },
    {
        icon: "13d",
        description: "snow",
        style:
            {
            backgroundImage: "var(--Snow_Small_Day)",
            backgroundSize: "50% 50%",
            opacity: "0.5",
            transform: "rotate(10deg)",
            animation: "fall 4s linear infinite",
            filter: "blur(2px)",
            },
    },
    {
        icon: "13n",
        description: "snow",
        style:
            {
            backgroundImage: "var(--Snow_Small_Night)",
            backgroundSize: "50% 50%",
            opacity: "0.2",
            transform: "rotate(10deg)",
            animation: "fall 5s linear infinite",
            filter: "blur(3px)",
            },
    },
    {
        icon: "50d",
        description: "mist",
        style: 
            {
            backgroundImage: "var(--MistCloud_Day)",
            backgroundSize: "cover",
            opacity: "0.4",
            transform: "rotate(-10deg)",
            animation: "fog 80s linear infinite",
            filter: "blur(20px)",
            },
    },
    {
        icon: "50n",
        description: "mist",
        style: 
            {
            backgroundImage: "var(--MistCloud_Night)",
            backgroundSize: "cover",
            opacity: "0.45",
            transform: "rotate(-30deg)",
            animation: "fog 160s linear infinite",
            filter: "blur(20px)",
            },
    },
];

export default portalLayer2;